<template>
  <div>
    <Checkup :checkup-id="$route.params.id"></Checkup>
  </div>
</template>
<script>
import Checkup from '@/components/Checkups/Checkup.vue'
import { mapMutations } from 'vuex'
export default {
  components: {
    Checkup
  },
  mounted () {
    this.setNavVisible(false)
    this.setHead({ url: '/p/checkups', text: this.$t('checkups') })
  },
  methods: {
    ...mapMutations({
      setNavVisible: 'app/setNavVisible',
      setHead: 'head/set'
    })
  }
}
</script>
<i18n>
{
  "ka": {
    "checkups": "ექსპრეს სკრინინგები"
  }
}
</i18n>
